import * as React from "react";

function BlogReformaIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.123 19.642a1.32 1.32 0 010 1.847c-.503.51-1.319.51-1.822 0L6.35 7.342l1.822-1.847 13.952 14.147zM18.057 8.53l-2.276 2.308-6.44-6.53L11.619 2l6.44 6.53zM11.618 15.059l-2.276 2.308-6.44-6.53L5.18 8.53l6.439 6.53zM1.5 20.912c0-.601.48-1.088 1.073-1.088h12.93a1.08 1.08 0 011.074 1.088A1.08 1.08 0 0115.504 22H2.574A1.08 1.08 0 011.5 20.912z"
        fill={props?.fill || "#0036B3"}
      />
    </svg>
  );
}

export default BlogReformaIcon;
